module.exports = "/chat-2486fb1f641514ca24d2ae8b9ad033cf.svg";